module.exports = __webpack_public_path__ + "static/media/mm.b87fca03.jpeg";